


import axios from "axios";

export const GET_ALL_TICKET_HISTORY = "GET_ALL_TICKET_HISTORY";
export const ADD_TICKET_HISTORY = "ADD_TICKET_HISTORY";
export const MODIF_TICKET_HISTORY = "MODIF_TICKET_HISTORY";
export const DELETE_TICKET_HISTORY = "DELETE_TICKET_HISTORY";
export const GET_ONE_TICKET_HISTORY = "GET_ONE_TICKET_HISTORY";

export const getAllTicketHistories = () => (dispatch) => {
    try {
        return axios.get("/ticket-histories")
                    .then(cli => {
                        dispatch({ type: GET_ALL_TICKET_HISTORY, payload: cli.data.data });
                    });
    } catch (error) {
        console.log("ERREUR GET ALL TICKET HISTORY ", error);
    }
};

export const addTicketHistory = (ticketHistoryState, history) => (dispatch) => {
    try {
        return axios.post("/ticket-histories", {data : ticketHistoryState})
                    .then(cli => {
                        dispatch({ type: ADD_TICKET_HISTORY, payload: cli.data });
                    });
    } catch (error) {
        console.log("ERREUR AJOUT HISTORY TICKET ", error);
    }
  };
  
  export const updateTicketHistory = (ticketHistoryState) => (dispatch) => {
    try {
        return axios.put(`/ticket-histories/${ticketHistoryState.id}`, ticketHistoryState)
                    .then(cli => {
                        dispatch({ type: MODIF_TICKET_HISTORY, payload: cli.data })
                    });
    } catch (error) {
        console.log("ERREUR MODIFICATION HISTORY TICKET ", error);
    }
  };
  
  export const deleteTicketHistory = (id) => (dispatch) => {
    try {
        return axios.delete(`/ticket-histories/${id}`)
                    .then((cli) => {
                        dispatch({ type: DELETE_TICKET_HISTORY, payload: cli.data });
                    });
    } catch (error) {
        console.log("ERREUR DELETE HISTORY TICKET ", error);
    }
  };
  
  export const getOneTicketHistory = (id) => (dispatch) => {
    try{
        return axios.get(`/ticket-histories/${id}`)
                    .then(rep => {
                        dispatch({ type: GET_ONE_TICKET_HISTORY, payload: rep.data });
                    });
    } catch (error) {
        console.log("ERREUR ", error);
    }
  };

  export const getAllTicketHistoriesByTicket = (ticketId) => (dispatch) => {
    try {
        const querya = `query getTicketHistories($tid:IDFilterInput!){
            ticketHistories (filters : {ticket : { documentId : $tid }},sort: "createdAt:desc") {
              documentId
              field
              oldValue
              newValue
              createdAt
              modifierUser {
                  documentId
                  username
                  email
                  name
                  lastname
              }
              documents {
                documentId
                name
                file {
                    documentId
                    name
                }
              }
            }
        }`;
        const variablesa = { "tid" : {eq : ticketId }}

        const body = {
            query : querya,
            variables : variablesa
        }

        return axios.post('/graphql', body);
    } catch (error) {
        console.log("ERREUR GET ALL TICKETS ", error);
    }
};

export const getAllTicketCommentsByTicket = (ticketId, user) => (dispatch) => {
    if(ticketId){
        try {
            const querya = `query getTicketComments($tid:IDFilterInput!){
                ticketHistories (
                    filters : {
                    ticket : { documentId : $tid }, 
                    field: {eq : "comments"}
                    ${user && user.role?.name?.toLowerCase() === 'client' ? ', sendToClient: { eq: true}': ''}
                },sort: "createdAt:desc") {
                  documentId
                  field
                  oldValue
                  newValue
                  createdAt
                  modifierUser {
                      documentId
                      username
                      email
                      name
                      lastname
                  }
                  documents {
                    documentId
                    name
                    file {
                        documentId
                        name
                        url
                    }
                  }
                }
            }`;
            const variablesa = { "tid" : {eq : ticketId }}
            // console.log(querya)
    
            const body = {
                query : querya,
                variables : variablesa
            }
    
            return axios.post('/graphql', body);
        } catch (error) {
            console.log("ERREUR GET ALL TICKETS ", error);
        }
    }
};

export const getLastCommentByTicket = (ticketId) => (dispatch) => {
    try {
        const querya = `query getLastComment($tid:IDFilterInput!){
            ticketHistories (filters : {ticket : { documentId : $tid }, field: "comments"},sort: "createdAt:desc", limit: 1) {
              documentId
              field
              oldValue
              newValue
              created_at
              modifierUser {
                  documentId
                  username
                  email
                  name
                  lastname
              }
              documents {
                documentId
                name
                file {
                    documentId
                    name
                }
              }
            }
        }`;
        const variablesa = { "tid" : { eq: ticketId }}

        const body = {
            query : querya,
            variables : variablesa
        }

        return axios.post('/graphql', body);
    } catch (error) {
        console.log("ERREUR GET ALL TICKETS ", error);
    }
};